import { render, staticRenderFns } from "./WalletFunding.vue?vue&type=template&id=1faf44d7&scoped=true"
import script from "./WalletFunding.vue?vue&type=script&lang=js"
export * from "./WalletFunding.vue?vue&type=script&lang=js"
import style0 from "./WalletFunding.vue?vue&type=style&index=0&id=1faf44d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf44d7",
  null
  
)

export default component.exports